import { useState, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";
import PrimaryButton from "./components/PrimaryButton";
import { useForm } from "react-hook-form";
import { Label } from "../components/Label/Label";
import { toast } from "react-toastify";
import WebService from "../Services/WebService";
import MobileLoader from "../components/MobileLoader/MobileLoader";

const getInitialPosIp = () => {
  const url = localStorage.getItem('pos_socket_url');
  if (!url) return "";
  try {
    const cleanUrl = url.replace("http://", "").replace("https://", "");
    return cleanUrl.split(":")[0];
  } catch {
    return "";
  }
};

const Login = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const { register, handleSubmit, setValue, formState: { errors, isValid } } = useForm({
    mode: "onChange",
    defaultValues: {
      mobile: "",
      pos_ip: getInitialPosIp()
    }
  });
  const [isLoading, setLoading] = useState(false)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setMobile(e.target.value.replace(/\D/g, "").slice(0, 10));
  };

  // const isValid = mobile.length === 10;

  // const handleLogin = () => {

  //   if (!isValid) return;
  //   navigate("/mobile/tables");
  // };

  const handleLogin = (data: any) => {
    setLoading(true)
    const payload = { mobile: data.mobile, unlock_code: 'SS-XY-1215' }
    WebService.postAPI({ action: `/waiter-login`, body: payload, id: 'login_btn' })
      .then((res: any) => {
        localStorage.setItem('access_token', res?.access_token)
        localStorage.setItem('tenantId', res?.tenant_id)
        localStorage.setItem('user_info', JSON.stringify(res?.user))

        // Dynamic socket URL calculation
        const host = window.location.hostname;
        const defaultSocketUrl = (host === 'localhost' || host === '127.0.0.1')
          ? 'http://localhost:3007'
          : `http://${host}:3007`;

        let customIp = data.pos_ip?.trim() || "";
        if (customIp) {
          if (!customIp.startsWith("http://") && !customIp.startsWith("https://")) {
            customIp = `http://${customIp}`;
          }
          if (!customIp.includes(":", 6)) {
            customIp = `${customIp}:3007`;
          }
          localStorage.setItem('pos_socket_url', customIp);
        } else {
          localStorage.setItem('pos_socket_url', defaultSocketUrl);
        }

        setLoading(false)
        navigate('/mobile/tables')
      })
      .catch((error: any) => {
        setLoading(false)
        toast.error(error.response?.data?.message || error.message)
      })
  }

  return (
    <>
      <MobileLoader show={isLoading} />
      <MobileTailwind />
      <div id="mobile-root" className="min-h-screen w-full bg-black flex justify-center">
        <div className="relative w-full min-h-screen overflow-hidden bg-[#111]">
          {/* Background image + dark overlay */}
          <div className="absolute inset-0 z-0">
            <img src="/mobile-assets/login-bg.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/70" />
          </div>
          <form onSubmit={handleSubmit(handleLogin)}>
            {/* Content */}
            <div className="relative z-10 flex flex-col items-center pt-20 px-4 pb-10">
              <img src="/mobile-assets/eagle.png" alt="" className="h-[130px] w-[130px] object-contain" />
              {/* Form */}
              <div className="w-full mt-20 flex flex-col gap-3">
                <div className="flex flex-col gap-2">
                  <h1 className="font-sansation font-bold text-white text-[24px] leading-tight">Login</h1>
                  <p className="font-opensans text-[#f4f4f5] text-[16px] leading-snug">  Enter your mobile number </p>
                </div>
                <div className="flex flex-col gap-2">
                  {/* <label className="font-opensans text-[14px] text-white">
                  Mobile Number
                </label> */}
                  <Label title="Mobile Number" showStar={true} classNames="font-opensans text-[14px] text-white" />
                  <div className="w-full h-[47px] rounded-[6px] border bg-white flex items-center gap-2 pl-3 pr-2" style={{ borderColor: "#C5C6CC" }} >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="shrink-0">
                      <rect x="3" y="5" width="18" height="14" rx="2" stroke="#8F9098" strokeWidth="1.8" />
                      <path d="M3 7l9 6 9-6" stroke="#8F9098" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                    {/* <input
                    type="tel"
                    value={mobile}
                    onChange={handleChange}
                    inputMode="numeric"
                    maxLength={10}
                    placeholder="Enter mobile number"
                    aria-label="Mobile number"
                    className="flex-1 min-w-0 bg-transparent border-0 outline-none font-opensans text-[14px] text-[#111] placeholder:text-[#8F9098]"
                  /> */}
                    <input
                      type="tel"
                      className="flex-1 min-w-0 bg-transparent border-0 outline-none font-opensans text-[14px] text-[#111] placeholder:text-[#8F9098]"
                      placeholder="Mobile Number"
                      maxLength={10}
                      {...register('mobile', {
                        required: "Mobile number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Enter valid mobile number"
                        }
                      })}
                    />
                  </div>
                  {errors?.mobile && (
                    <small className="text-danger">
                      {String(errors.mobile.message)}
                    </small>
                  )}
                </div>
                {/* <div className="flex flex-col gap-2">
                  <Label title="POS Server IP (Optional)" showStar={false} classNames="font-opensans text-[14px] text-white" />
                  <div className="w-full h-[47px] rounded-[6px] border bg-white flex items-center gap-2 pl-3 pr-2" style={{ borderColor: "#C5C6CC" }} >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="shrink-0" stroke="#8F9098" strokeWidth="1.8">
                      <rect x="2" y="3" width="20" height="14" rx="2" fill="none" />
                      <line x1="6" y1="21" x2="18" y2="21" />
                      <line x1="12" y1="17" x2="12" y2="21" />
                    </svg>
                    <input
                      type="text"
                      className="flex-1 min-w-0 bg-transparent border-0 outline-none font-opensans text-[14px] text-[#111] placeholder:text-[#8F9098]"
                      placeholder="e.g. 192.168.1.15"
                      {...register('pos_ip')}
                    />
                  </div>
                </div> */}
                <PrimaryButton type="submit" disabled={!isValid}>
                  Login
                </PrimaryButton>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
